import React from 'react';
import styled from 'styled-components';

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: 'Arial', sans-serif;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
`;

const Input = styled.input`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  color: #333;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: #0e4d8c;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.2);
  }

  &::placeholder {
    color: #aaa;
  }
`;

const Button = styled.button`
  padding: 0.8rem;
  background: #005983;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: white;
    color: #005983;
    border: 1px solid #005983;
  }

  &:disabled {
    background: #ddd;
    cursor: not-allowed;
  }
`;

const UserProfileForm = ({ userData, handleChange, handleSubmit }) => {
  return (
    <StyledForm onSubmit={handleSubmit}>
      <FormGroup>
        <Label>Nom</Label>
        <Input
          type="text"
          name="name"
          value={userData.name}
          onChange={handleChange}
          required
          placeholder="Entrez votre nom"
        />
      </FormGroup>

      <FormGroup>
        <Label>Intitulé du métier</Label>
        <Input
          type="text"
          name="jobTitle"
          value={userData.jobTitle}
          onChange={handleChange}
          required
          placeholder="Entrez votre intitulé"
        />
      </FormGroup>

      <FormGroup>
        <Label>Adresse</Label>
        <Input
          type="text"
          name="address"
          value={userData.address}
          onChange={handleChange}
          required
          placeholder="Entrez votre adresse"
        />
      </FormGroup>

      <FormGroup>
        <Label>Numéro de téléphone</Label>
        <Input
          type="text"
          name="phoneNumber"
          value={userData.phoneNumber}
          onChange={handleChange}
          required
          placeholder="Entrez votre numéro de téléphone"
        />
      </FormGroup>

      {/* <FormGroup>
        <Label>Email</Label>
        <Input
          type="email"
          name="email"
          value={userData.email}
          onChange={handleChange}
          required
          placeholder="Entrez votre email"
        />
      </FormGroup> */}

      <FormGroup>
        <Label>Numéro de facture</Label>
        <Input
          type="number"
          name="invoiceNumber"
          value={userData.invoiceNumber}
          onChange={handleChange}
          required
          placeholder="Entrez votre numéro de facture"
        />
      </FormGroup>

      <Button type="submit">Sauvegarder</Button>
    </StyledForm>
  );
};

export default UserProfileForm;
